<template>
  <div ref="moderationSummaryWrapper" class="moderation-summary__wrapper">
    <div
      ref="moderationSummary"
      class="moderation-summary"
      :class="{ 'moderation-summary--fixed': isFixed }"
      :style="{ width: width }"
    >
      <Section title="Weryfikacja wydarzenia">
        <section class="moderation-summary__actions">
          <Btn
            v-if="briefUrl"
            :href="briefUrl"
            variant="link"
            size="sm"
            icon="download-alt"
            title="Program ramowy"
          ></Btn>
          &nbsp;
          <Btn
            v-if="programmeUrl"
            :href="programmeUrl"
            variant="link"
            size="sm"
            icon="download-alt"
            title="Program szczegółowy"
          ></Btn>
          &nbsp;
          <Btn
            v-if="url"
            :href="url"
            size="sm"
            icon="external-link-alt"
            variant="link"
            title="Strona"
            target="_blank"
          ></Btn>
        </section>

        <section class="moderation-summary__comments">
          <h4 class="moderation-summary__label">
            Komentarz organizatora:
          </h4>
          <div class="comment">
            <!-- <p v-if="applicantComment.comment" class="comment__meta">
              <span class="comment__user">
                {{ applicantComment.user }}
              </span>
              <span class="comment__date">
                {{ applicantComment.date | moment("YYYY-MM-DD") }}
              </span>
            </p> -->
            <p class="comment__message">
              <span v-if="applicantComment.comment">
                {{ applicantComment.comment | truncate(250) }}
              </span>
              <span v-else>
                Brak
              </span>
              <a
                href="#"
                @click.prevent="
                  showAllComments(
                    'Komentarze organizatora',
                    null,
                    applicantComments
                  )
                "
              >
                (więcej)
              </a>
            </p>
          </div>
        </section>

        <section class="moderation-summary__comments">
          <h4 class="moderation-summary__label">Komentarz CO:</h4>
          <div class="comment">
            <!-- <p v-if="adminComment.comment" class="comment__meta">
              <span class="comment__user">
                {{ adminComment.user }}
              </span>
              <span class="comment__date">
                {{ adminComment.date | moment("YYYY-MM-DD") }}
              </span>
            </p> -->
            <p class="comment__message">
              <span v-if="adminComment.comment">
                {{ adminComment.comment | truncate(250) }}
              </span>
              <span v-else>
                Brak
              </span>
              <a
                href="#"
                @click.prevent="
                  showAllComments(
                    'Komentarze CO',
                    adminComment,
                    adminComments,
                    'SET_STAFF_COMMENTS'
                  )
                "
              >
                <template v-if="adminComment.comment || moderationDisabled">
                  (więcej)
                </template>
                <template v-else>
                  (dodaj)
                </template>
              </a>
            </p>
          </div>
        </section>

        <section class="moderation-summary__comments">
          <h4 class="moderation-summary__label">
            Komentarz publiczny:
          </h4>
          <div class="comment">
            <!-- <p v-if="publicComment.comment" class="comment__meta">
              <span class="comment__user">
                {{ publicComment.user }}
              </span>
              <span class="comment__date">
                {{ publicComment.date | moment("YYYY-MM-DD") }}
              </span>
            </p> -->
            <p class="comment__message">
              <span v-if="publicComment.comment">
                {{ publicComment.comment | truncate(250) }}
              </span>
              <span v-else>
                Brak
              </span>

              <a
                href="#"
                @click.prevent="
                  showAllComments(
                    'Komentarze publiczne',
                    publicComment,
                    publicComments,
                    'SET_PUBLIC_COMMENTS'
                  )
                "
              >
                <template v-if="publicComment.comment || moderationDisabled">
                  (więcej)
                </template>
                <template v-else>
                  (dodaj)
                </template>
              </a>
            </p>
          </div>
        </section>
      </Section>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ModelFactory from "@/model/ModelFactory";
import BaseAdminCertificationSummaryComment from "./BaseAdminCertificationSummaryComment";
import FileApi from "@/api/File";

const filterComments = function(comments, type) {
  return comments.filter(item => item.type === type);
};

const createCommentModel = function(comment) {
  if (Array.isArray(comment)) {
    comment = comment[0];
  }
  return ModelFactory.create("CommentModel", comment);
};

export { filterComments, createCommentModel };

export default {
  name: "BaseAdminCertificationSummary",
  components: {
    BaseAdminCertificationSummaryComment
  },
  data() {
    return {
      isFixed: false,
      width: 0,
      applicantComment: ModelFactory.create("CommentModel"),
      adminComment: ModelFactory.create("CommentModel"),
      publicComment: ModelFactory.create("CommentModel"),
      dialogComponent: "BaseAdminCertificationSummaryComment"
    };
  },
  computed: {
    ...mapState("Event", ["event", "comments", "moderationDisabled"]),
    ...mapGetters("Event", [
      "applicantComments",
      "adminComments",
      "publicComments"
    ]),
    programmeUrl() {
      let file = this.event.getProgramme();
      return file ? FileApi.getDownloadUrl(file[0].file) : false;
    },
    briefUrl() {
      let file = this.event.getBrief();
      return file ? FileApi.getDownloadUrl(file[0].file) : false;
    },
    url() {
      return this.event.url;
    }
  },
  watch: {
    publicComments(allComments) {
      this.publicComment = createCommentModel(
        filterComments(allComments, "current")
      );
    },
    adminComments(allComments) {
      this.adminComment = createCommentModel(
        filterComments(allComments, "current")
      );
    },
    applicantComments(allComments) {
      this.applicantComment = createCommentModel(
        filterComments(allComments, "current")
      );
    }
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.setWidth);
  },
  mounted() {
    this.setWidth();
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.setWidth);
  },
  methods: {
    onScroll() {
      this.$set(
        this,
        "isFixed",
        window.pageYOffset > 220 && window.innerWidth > 1023
      );
    },
    setWidth() {
      this.$set(
        this,
        "width",
        `${this.$refs.moderationSummaryWrapper.offsetWidth}px`
      );
    },
    showAllComments(title, comment, comments, mutation) {
      let self = this;
      const h = this.$createElement;
      const titleNode = h("div", { domProps: { innerHTML: title } });
      const commentNodes = h(this.dialogComponent, {
        props: {
          value: comment || null,
          comments
        },
        on: {
          input: function($e) {
            if (mutation) {
              self.$store.commit(`Event/${mutation}`, $e);
            }
          }
        }
      });

      const bodyNode = h("div", { class: ["moderation-summary__dialog"] }, [
        commentNodes
      ]);

      this.$bvModal.msgBoxOk([bodyNode], {
        title: [titleNode],
        buttonSize: "sm",
        size: "xl",
        scrollable: true
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables";

.moderation-summary {
  position: relative;
  width: 100%;

  &--fixed {
    position: fixed;
    top: 30px;
  }

  .section__header {
    margin-bottom: 10px;
  }

  &__actions {
    border-bottom: 1px solid $col-polmed-gray;
    text-align: center;
    margin-bottom: 10px;
    padding-bottom: 10px;
  }

  &__label {
    font-size: 0.8em;
    margin: 0;
  }

  .comment {
    margin: 0;
    padding: 0;
  }

  &__comments {
    border-bottom: 1px solid $col-polmed-gray;
    font-size: 0.85em;
    padding-bottom: 10px;
    margin-bottom: 10px;
    &:last-child {
      border-bottom: none;
    }
  }
}

.moderation-summary__dialog {
  textarea {
    font-size: 1em;
  }

  .moderation-summary__comments {
    .comment__message-reuse {
      opacity: 0;
      transition: opacity 0.3s;
    }
    &:hover {
      .comment__message-reuse {
        opacity: 1;
      }
    }
  }
}
</style>
